export default __webpack_public_path__ + "static/media/Meralda.7f08d36b.jpg";